/* eslint-disable react/no-danger */
import React from "react";
import {useTranslation} from "react-i18next";

const Partner = () => {
  const {t} = useTranslation("about");

  return (
    <div className="container px-4 py-6">
      <div
        dangerouslySetInnerHTML={{__html: t("rivieraFineArt")}}
      />

      <div
        className="mt-6"
        dangerouslySetInnerHTML={{__html: t("eunomart")}}
      />

      <div
        className="mt-6"
        dangerouslySetInnerHTML={{__html: t("metaKart")}}
      />
    </div>
  );
};

Partner.displayName = "Partner";
export default Partner;
